var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":_vm.value,"width":"100%","height":"100%","frameborder":"0","allow":"autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture","loading":"lazy"}})
}
var staticRenderFns = []

export { render, staticRenderFns }